import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { usePriceListStore } from './price-list';
import { getRequestIns } from '../requestIns';
export const useRuleCheckStore = defineStore('rule-check', {
    state() {
        return {
            lastRequest: null,
            lastResponse: null,
            isFirstEntry: true,
        };
    },
    actions: {
        setIsFirstEntry(isFirstEntry) {
            this.isFirstEntry = isFirstEntry;
        },
        /**
         * 检查规则逻辑
         * @param params
         */
        async getRuleCheck(params) {
            try {
                const priceListStore = usePriceListStore();
                const requestParams = {
                    current_total_price: priceListStore.totalPrice,
                    first_time_entry: this.isFirstEntry,
                    ...params,
                };
                const result = await configRequest(getRequestIns()).ruleCheck(requestParams, {
                    showToast: true,
                    showBizToast: true,
                    throwError: true,
                });
                const nextResponse = result?.data ?? null;
                this.lastRequest = requestParams;
                this.lastResponse = nextResponse ?? null;
                return nextResponse ?? null;
            }
            catch (error) {
                throw error;
            }
        },
    },
});
